import { Box, Button, Nav, Sidebar, Text } from "grommet"
import { useState } from "react"
import { useTranslation } from "react-i18next";

const SidebarSection = ({ navs, ...props }) => {

    const [currentComponent, setCurrentComponent] = useState(navs[0]);

    const handleNavClick = (nav) => {
        setCurrentComponent(nav);
    }

    return (
        <Box direction="row" {...props}>
            <Sidebar basis="45%">
                <Nav gap="small">
                    {navs.map(nav => (
                        <SidebarButton nav={nav} onClick={() => handleNavClick(nav)} active={nav.component === currentComponent.component} />
                    ))}
                </Nav>
            </Sidebar>
            <Box basis="55%" style={{ minHeight: '500px' }}>
                {currentComponent.component}
            </Box>
        </Box>
    )
}

const SidebarButton = ({ nav, active, onClick }) => {

    const { t } = useTranslation();
    const [isActiveHover, setActiveHover] = useState(false);

    return (
        <Box direction="row" pad={{ vertical: 'small', horizontal: '18px' }} onClick={onClick} style={{ position: "relative" }} round="xsmall" background={active ? 'background-contrast' : 'none'} hoverIndicator focusIndicator={false} onMouseEnter={() => setActiveHover(true)} onMouseLeave={() => setActiveHover(false)}>
            {(isActiveHover || active) && <Box width={'6px'} style={{ position: "absolute", left: 0, top: 0, bottom: 0, borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' }} background={'brand'}></Box>}
            <Button label={<Text style={{ whiteSpace: 'nowrap' }}>{t(nav.label)}</Text>} icon={nav.icon} plain fill justify="start" />
        </Box>
    )
}

export default SidebarSection; 